export const skipSetup = (skip?: number | null): number => {
	return typeof skip === 'number' && skip > 0 ? skip : 0
}
